var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"color":"#006aff","border":"1px solid #006aff"},attrs:{"size":_vm.size,"plain":_vm.plain},on:{"click":function($event){return _vm.download()}}},[_vm._v("导出")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6210a56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/excel/ExportExcel.vue
// module id = null
// module chunks = 